<style scoped>
.search-field-text {
  width: 400px;
}
.nav-wrapper {
  background: var(--kf-surface) !important;
  box-shadow: var(--kf-shadow-chrome) !important;
  border-bottom: 1px solid var(--kf-border-strong) !important;
}
.search-box-wrapper {
  position: relative;
}
.search-box-text {
  width: 350px;
  padding: 10px 15px 10px 50px;
  margin-top: 5px;
  border-radius: 20px;
  background: var(--kf-surface-2);
  height: fit-content !important;
  border: 1px solid var(--kf-border) !important;
  color: var(--kf-text-body);
}
.search-box-icon-wrapper {
  position: absolute;
  top: 16px;
  left: 15px;
  /* transform: translate(0, 50%); */
  padding: 2px;
  border-radius: 50%;
  background: var(--kf-control) !important;
  border: 1px solid var(--kf-border) !important;
  display: grid;
  place-items: center;
  /* background: blue; */
}
.search-box-icon {
  /* background: blue; */
}
.search-instruction {
  color: red;
  font-weight: 600;
  font-size: 12px !important;
  display: flex;
  justify-content: end;
}
/* The sidebar toggle shares the back button's treatment rather than defining
   its own: they sit side by side in the same bar, so one set of shadow values
   keeps them from drifting apart. The gradient icon is deliberately not
   shared -- that marks "go back", which this button does not do. */
.back-btn,
.collapse-btn {
  padding: 5px;
  border-radius: 50%;
  background: var(--kf-control) !important;
  border: 1px solid var(--kf-border) !important;
}
.back-icon {
  font-weight: 900;
  background-color: #ffd641;
  background-image: linear-gradient(90deg, #ffd641 0%, #ff003c 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.back-btn:hover,
.collapse-btn:hover {
  background: var(--kf-hover);
  border-color: var(--kf-border-strong) !important;
}
.close-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  /* padding: 5px; */
  border-radius: 50%;
  /* background: #eef5fb !important; */
  /* border: 1px solid #a9d7ff57 !important; */

  /* box-shadow: 6px 6px 12px #dbe1e7, -6px -6px 12px #ffffff !important; */
}
.close-icon {
  font-weight: 900;
  background-color: #ffd641;
  background-image: linear-gradient(90deg, #ffd641 0%, #ff003c 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>
<template>
  <v-app-bar
    absolute
    app
    class="elevation-0  nav-wrapper"
    color="white"
    height="75"
  >
    <!--      scroll-target="#scrolling-techniques-7"-->

    <!-- <v-btn
      v-if="$route.meta.show_back_btn"
      fab
      small
      text
      @click="$router.go(-1)"
    >
      <v-icon color="#333333">mdi-chevron-left</v-icon>
    </v-btn> -->
    <!-- One stable shape in both states: whether the sidebar is open is
         already visible from the sidebar itself, so the button does not need
         to restate it. With the icon fixed, the title and aria-expanded are
         what say which way the click goes. -->
    <button
      class="collapse-btn ml-2 mr-4"
      :title="isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'"
      :aria-label="isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'"
      :aria-expanded="String(!isCollapsed)"
      @click="toggleSidebar"
    >
      <v-icon color="#333333">mdi-menu</v-icon>
    </button>

    <button
      v-if="$route.meta.show_back_btn"
      class="back-btn mr-4"
      @click="$router.go(-1)"
    >
      <v-icon class="back-icon">
        mdi-chevron-left
      </v-icon>
    </button>

    <v-toolbar-title class="font-bold" style="color: #333333">
      <span v-if="$route.meta.title == 'LAS'">Loan Against Securities</span>
      <span v-else>
        {{ $route.meta.display_title || $route.meta.title }}
      </span>
    </v-toolbar-title>

    <v-spacer></v-spacer>
    <v-spacer></v-spacer>
    <div v-if="showGlobalSearch" class="search-box-wrapper">
      <div class="search-box-icon-wrapper">
        <v-icon size="20" class="search-box-icon">mdi-magnify</v-icon>
      </div>
      <input
        v-model="display_search_text"
        @input="saveSearchText()"
        type="text"
        class="search-box-text"
        :placeholder="$route.meta.search_placeholder || 'Search'"
      />
      <button
        v-if="display_search_text"
        class="close-btn"
        @click="clearSearchText()"
      >
        <v-icon class="close-icon">
          mdi-window-close
        </v-icon>
      </button>
      <!-- <div class="search-instruction">
        ** Press ENTER to search
      </div> -->
    </div>
    <!-- <div
      v-if="$route.meta.title != 'Customer details'"
      class="search-field-text pt-2"
    >
      <v-text-field
        v-model="display_search_text"
        dense
        hide-details
        label="Search"
        outlined
        prepend-inner-icon="mdi-magnify"
        rounded
        single-line
        v-on:keyup.enter="saveSearchText()"
      >
        <template slot="append">
          <v-icon v-if="display_search_text" @click="clearSearchText()"
            >mdi-close</v-icon
          >
        </template></v-text-field
      >
      <div class="red--text text-caption text-right">
        ** Press ENTER to search
      </div>
    </div> -->
  </v-app-bar>
</template>
<script>
  import debounce from "lodash/debounce";

const MIN_SEARCH_LENGTH = 3;

export default {
  props: ["filter_status"],
  data() {
    return {
      display_search_text: "",
    };
  },

  // Clear search text on route change
  // watch: {
  // $route(to, from) {
  //   console.log("here");
  //   this.search_text = "";
  //   this.$store.dispatch("setSearchText", "");
  // },
  // },

  created() {
    // console.log(this.$route.meta.show_back_btn);
    // create debounced function ONCE
    this.debouncedSaveSearchText = debounce(() => {
      const text = (this.display_search_text || "").trim();
      // A 1-2 character search matches most of the table and costs a full scan
      // for a result nobody wants. Treat it as "not searching yet" so the list
      // stays unfiltered until the query is selective enough.
      const query = text.length < MIN_SEARCH_LENGTH ? "" : text;
      if (query === this.$store.getters["getSearchText"]) return;
      this.$store.dispatch("setSearchText", query);
    }, 500); // debounce delay (ms)

  },
  methods: {
    toggleSidebar() {
      this.$store.dispatch("drawer/toggleCollapsed");
    },
    // applySearch(status) {
    //   this.$store.dispatch("setSearchText", this.search_text);
    // },
    saveSearchText() {
      // this.$store.dispatch("setSearchText", this.display_search_text);
      this.debouncedSaveSearchText();
    },
    clearSearchText() {
      this.display_search_text = "";
      this.$store.dispatch("setSearchText", "");
    },
  },
  // getting and setting search value from store
  watch: {
    search_text(newValue) {
      // Don't wipe a query the user is still typing: below MIN_SEARCH_LENGTH we
      // deliberately hold the store at "" while the box keeps its text.
      if (
        newValue === "" &&
        (this.display_search_text || "").trim().length < MIN_SEARCH_LENGTH
      ) {
        return;
      }
      this.display_search_text = newValue;
    },
  },
  computed: {
    isCollapsed() {
      return this.$store.getters["drawer/isCollapsed"];
    },
    /**
     * This box writes to one shared value, which 21 legacy pages read and no
     * KarroFin page reads -- so on a KarroFin screen it was a search that
     * searched nothing, sitting 60px above the FilterBar search that works.
     * Routes opt out via `meta.show_global_search: false`; anything that does
     * not say so keeps the box, which is every legacy route.
     */
    showGlobalSearch() {
      return (
        !this.$route.meta.show_back_btn &&
        this.$route.meta.show_global_search !== false
      );
    },
    search_text: {
      get() {
        return this.$store.getters["getSearchText"];
      },
      set(newValue) {
        return this.$store.dispatch("setSearchText", newValue);
      },
    },
  },
   beforeDestroy() {
    // Vue cleanup
    this.debouncedSaveSearchText.cancel();
  },
};
</script>
